// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 10 10%27><path d=%27M1 5L4 8L9 2%27 stroke=%27black%27 stroke-width=%271.6%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Shared cross-cutting atoms only.
   Component styles live colocated with their component
   (ui/PageHead/PageHead.css, ui/Table/Table.css, ui/StagePill,
   ui/Pager, ui/SearchField, ui/Filters) and page styles with their
   page (pages/diligencias/Diligencias.css). This file holds only the
   cross-cutting primitives rendered as raw classes across many pages:
   the screen wrapper, type utilities, buttons, status dots, tabs, the
   selection bar, tooltips and the reveal animation. Tokens: tokens.css.
   ============================================================ */

/* ---------- screen wrapper ---------- */
/* Full-bleed by default: dashboard/list/data screens use the full content width
   inside the gutter. Reading/detail views constrain their
   OWN inner column (CausaDetalleVista 640px, VerDiligencia 660px, settings 52ch),
   so no blanket cap belongs here — a blanket 1200px cap was pinning content left
   and leaving a right-side gap on wide screens. \`.page--narrow\` opts a whole view
   into a centered measure when one is wanted. */
.page {
  padding: var(--s-8) var(--gutter) var(--s-20);
}
.page--wide {
  max-width: none;
}
.page--narrow {
  max-width: var(--content-max);
  margin-inline: auto;
}

/* ---------- type utilities (scoped under .page where they collide) ---------- */
.page .kicker {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--ink-3);
}
.page .mono {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
}
.page .serif {
  font-family: var(--serif);
  font-weight: 400;
}
.note {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  letter-spacing: 0.08em;
  color: var(--ink-3);
}

/* ---------- toolbar + segmented control + pills ---------- */
.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 0;
  flex-wrap: wrap;
}
.toolbar__spacer {
  flex: 1;
}
.chips {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
}
.pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 34px;
  padding: 0 13px;
  font-size: var(--fs-2xs);
  border: 1px solid var(--rule);
  background: transparent;
  color: var(--ink-2);
  border-radius: var(--r-pill);
  cursor: pointer;
  transition: all var(--dur-1) var(--ease);
  white-space: nowrap;
}
.pill:hover {
  border-color: var(--ink-3);
  color: var(--ink);
}
.pill--on {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent-deep);
}
.pill__n {
  font-family: var(--mono);
  font-size: var(--fs-eyebrow);
  opacity: 0.8;
}
.seg {
  display: inline-flex;
  border: 1px solid var(--rule);
  border-radius: var(--r-1);
  overflow: hidden;
}
.seg button {
  background: transparent;
  border: 0;
  height: 32px;
  padding: 0 12px;
  display: inline-flex;
  align-items: center;
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--ink-3);
  cursor: pointer;
}
.seg button.is-on {
  background: var(--ink);
  color: var(--paper);
}

/* ---------- tabs (lifecycle bar) ---------- */
.tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid var(--rule);
  flex-wrap: wrap;
}
.tab {
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 11px 16px 11px 0;
  margin-right: 22px;
  margin-bottom: -1px;
  font-family: var(--sans);
  font-size: var(--fs-note);
  font-weight: 500;
  color: var(--ink-3);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.tab:hover {
  color: var(--ink);
}
.tab--on {
  color: var(--ink);
  border-bottom-color: var(--accent);
}
.tab__n {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--ink-3);
}

/* ---------- status text + dot ---------- */
.st {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: var(--fs-ui);
}
.st__dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: currentColor;
  flex: none;
}
.st--ok {
  color: var(--ok);
}
.st--warn {
  color: var(--warn);
}
.st--err {
  color: var(--err);
}
.st--info {
  color: var(--info);
}
.st--mute {
  color: var(--ink-3);
}
.st--ready {
  color: var(--accent);
}
.st--live {
  color: #1090ba;
}

/* ---------- bulk-selection bar ---------- */
.selbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  border: 1px solid var(--accent);
  background: var(--accent-soft);
  margin: 14px 0 -1px;
}
.selbar--total {
  border-color: var(--rule);
  background: var(--paper-elev);
}
.selbar__n {
  font-size: var(--fs-ui);
  color: var(--ink);
}
.selbar__n b {
  font-family: var(--mono);
}
.selbar__sp {
  flex: 1;
}

/* ---------- dashed empty state + "no diligencia" cell ---------- */
.empty {
  border: 1px dashed var(--rule);
  padding: 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.empty__t {
  font-size: var(--fs-note);
  color: var(--ink);
}
.dil-none {
  font-size: var(--fs-2xs);
  color: var(--ink-3);
}

/* ---------- future-feature badge ---------- */
.soon-badge {
  font-family: var(--mono);
  font-size: var(--fs-pico);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  border: 1px solid var(--rule);
  color: var(--ink-3);
  padding: 1px 5px;
  border-radius: 2px;
  vertical-align: middle;
  margin-left: 4px;
}

/* ---------- CSS tooltip (disambiguate a label) ---------- */
.tip {
  position: relative;
  border-bottom: 1px dotted var(--ink-3);
  cursor: help;
}
.tip::after {
  content: attr(data-tip);
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  transform: translateX(-50%) translateY(4px);
  background: var(--ink);
  color: var(--paper);
  font-family: var(--sans);
  font-size: var(--fs-meta);
  font-weight: 400;
  line-height: 1.4;
  letter-spacing: 0;
  text-transform: none;
  padding: 7px 10px;
  width: max-content;
  max-width: 240px;
  white-space: normal;
  text-align: left;
  border-radius: var(--r-1);
  opacity: 0;
  pointer-events: none;
  z-index: 120;
  transition:
    opacity var(--dur-1) var(--ease),
    transform var(--dur-1) var(--ease);
}
.tip::before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: calc(100% + 3px);
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: var(--ink);
  opacity: 0;
  pointer-events: none;
  z-index: 120;
  transition: opacity var(--dur-1) var(--ease);
}
.tip:hover::after {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}
.tip:hover::before {
  opacity: 1;
}
th .tip {
  border-bottom: 0;
  text-decoration: underline dotted var(--ink-3);
  text-underline-offset: 3px;
}
/* A header tooltip opens below its cell: above it would leave .tbl-wrap, whose
   overflow-x clips the top edge, and the th clipped it as well. */
th .tip::after {
  bottom: auto;
  top: calc(100% + 8px);
  transform: translateX(-50%) translateY(-4px);
}
th .tip::before {
  bottom: auto;
  top: calc(100% + 3px);
  border-top-color: transparent;
  border-bottom-color: var(--ink);
}
/* In the last or a right-aligned column the tooltip hangs to the left of its
   label, so it never extends past the table's right edge (which would add a
   horizontal scrollbar to .tbl-wrap). */
th:last-child .tip::after,
th.num .tip::after {
  left: auto;
  right: 0;
  transform: translateY(-4px);
}
th:last-child .tip:hover::after,
th.num .tip:hover::after {
  transform: translateY(0);
}
th:last-child .tip::before,
th.num .tip::before {
  left: auto;
  right: 8px;
  transform: none;
}

/* ---------- reveal (screen enter) ---------- */
@media (prefers-reduced-motion: no-preference) {
  .reveal {
    animation: reveal var(--dur-3) var(--ease);
  }
}
@keyframes reveal {
  from {
    transform: translateY(6px);
  }
  to {
    transform: none;
  }
}

/* ---------- DS button (.t-btn) ---------- */
.t-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  font-family: var(--sans);
  font-size: var(--fs-ui);
  font-weight: 500;
  letter-spacing: 0.02em;
  border: 1px solid var(--text);
  background: var(--text);
  color: var(--bg);
  border-radius: var(--radius-0);
  cursor: pointer;
  transition: all var(--dur-1) var(--ease);
  text-decoration: none;
}
.t-btn:hover {
  background: color-mix(in oklab, var(--text) 82%, var(--bg));
  border-color: color-mix(in oklab, var(--text) 82%, var(--bg));
}
.t-btn:active {
  background: color-mix(in oklab, var(--text) 68%, var(--bg));
}
.t-btn:focus-visible {
  outline: 2px solid var(--text);
  outline-offset: 2px;
}
.t-btn--ghost {
  background: transparent;
  color: var(--text);
}
.t-btn--ghost:hover {
  background: var(--bg-alt);
}
.t-btn--quiet {
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border);
}
/* The base .t-btn:hover / :active paint a dark fill for the solid button. The
   quiet variant keeps its transparent background, otherwise its dark hover
   text lands on that fill. */
.t-btn--quiet:hover {
  background: transparent;
  border-color: var(--text);
  color: var(--text);
}
.t-btn--quiet:active {
  background: color-mix(in oklab, var(--text) 8%, transparent);
  border-color: var(--text);
  color: var(--text);
}
.t-btn--sm {
  padding: 6px 10px;
  font-size: var(--fs-meta);
}
.t-btn--lg {
  padding: 14px 22px;
  font-size: var(--fs-note);
}
.t-btn--primary {
  background: var(--signal);
  border-color: var(--signal);
  color: #fff;
}
.t-btn--primary:hover {
  background: var(--signal-deep);
  border-color: var(--signal-deep);
}
.t-btn[disabled],
.t-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}
.t-btn .kbd {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0;
  opacity: 0.7;
  border: 1px solid currentColor;
  border-radius: 2px;
  padding: 0 4px;
  line-height: 1.4;
}
.t-btn--ghost .kbd,
.t-btn--quiet .kbd {
  border-color: var(--rule);
}

/* ---------- row-action (small secondary button in table rows / card tiles) ---------- */
.row-action {
  height: 26px;
  padding: 0 11px;
  border: 1px solid var(--border);
  border-radius: var(--radius-1);
  background: var(--bg-alt);
  color: var(--text-secondary);
  font-family: var(--sans);
  font-size: var(--fs-xs);
  font-weight: 500;
  letter-spacing: -0.001em;
  cursor: pointer;
  transition:
    background 110ms ease,
    border-color 110ms ease,
    color 110ms ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.row-action:hover {
  background: var(--bg);
  border-color: var(--text-secondary);
  color: var(--text);
}

.row-action.danger {
  color: var(--danger);
  border-color: rgba(180, 35, 24, 0.35);
}

.row-action.danger:hover {
  background: var(--err-bg);
  border-color: var(--danger);
}

.row-action--disabled,
.row-action--disabled:hover {
  color: var(--text-muted);
  border-color: var(--border);
  background: var(--bg-alt);
  cursor: not-allowed;
  opacity: 0.55;
}

/* ---------- DS checkbox (.t-check) ---------- */
.t-check {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: var(--fs-note);
}
.t-check input {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid var(--border);
  background: var(--surface);
  display: grid;
  place-items: center;
  cursor: pointer;
  border-radius: 2px;
  margin: 0;
}
.t-check input:checked {
  background: var(--accent);
  border-color: var(--accent);
}
.t-check input:checked::after {
  content: '';
  width: 10px;
  height: 10px;
  /* The check is a mask painted with --accent-ink, so it follows the accent
     in both themes (a white stroke is unreadable on the dark accents). */
  background: var(--accent-ink);
  -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    center/contain no-repeat;
  mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    center/contain no-repeat;
}

/* ── tag — mono mini pill, tone-tinted. Shared primitive used by
   the diligencia detail, the Inicio foco cards, and any tone label. ── */
.tag {
  display: inline-flex;
  align-items: center;
  font-family: var(--mono);
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 2px 7px;
  border: 1px solid var(--rule);
  color: var(--ink-3);
  border-radius: var(--radius-1, 2px);
}
.tag--ok {
  border-color: var(--ok);
  color: var(--ok);
}
.tag--err {
  border-color: var(--err);
  color: var(--err);
}
.tag--warn {
  border-color: var(--warn);
  color: var(--warn);
}
.tag--ready {
  border-color: var(--accent);
  color: var(--accent);
}
.tag--info {
  border-color: var(--info);
  color: var(--info);
}
.tag--live {
  border-color: var(--info);
  color: var(--info);
}
.tag--mute {
  border-color: var(--rule);
  color: var(--ink-3);
}
`, "",{"version":3,"sources":["webpack://./src/styles/atoms.css"],"names":[],"mappings":"AAAA;;;;;;;;;iEASiE;;AAEjE,yCAAyC;AACzC;;;;;gDAKgD;AAChD;EACE,6CAA6C;AAC/C;AACA;EACE,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,MAAM;EACN,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,OAAO;AACT;;AAEA,oEAAoE;AACpE;EACE,8BAA8B;EAC9B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,+CAA+C;AAC/C;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,2CAA2C;EAC3C,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ;;sCAEoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,4CAA4C;AAC9C;AACA;EACE,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,0BAA0B;AAC5B;AACA;kEACkE;AAClE;EACE,YAAY;EACZ,qBAAqB;EACrB,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;;wCAEwC;AACxC;;EAEE,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,UAAU;EACV,UAAU;EACV,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE;IACE,0CAA0C;EAC5C;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;;AAEA,6CAA6C;AAC7C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,wCAAwC;EACxC,qBAAqB;AACvB;AACA;EACE,2DAA2D;EAC3D,6DAA6D;AAC/D;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;AACjC;AACA;;6BAE6B;AAC7B;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,4DAA4D;EAC5D,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,yFAAyF;AACzF;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf;;;oBAGkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ;yEACuE;EACvE,6BAA6B;EAC7B;4BAC0B;EAC1B;4BAC0B;AAC5B;;AAEA;yEACyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":["/* ============================================================\n   Shared cross-cutting atoms only.\n   Component styles live colocated with their component\n   (ui/PageHead/PageHead.css, ui/Table/Table.css, ui/StagePill,\n   ui/Pager, ui/SearchField, ui/Filters) and page styles with their\n   page (pages/diligencias/Diligencias.css). This file holds only the\n   cross-cutting primitives rendered as raw classes across many pages:\n   the screen wrapper, type utilities, buttons, status dots, tabs, the\n   selection bar, tooltips and the reveal animation. Tokens: tokens.css.\n   ============================================================ */\n\n/* ---------- screen wrapper ---------- */\n/* Full-bleed by default: dashboard/list/data screens use the full content width\n   inside the gutter. Reading/detail views constrain their\n   OWN inner column (CausaDetalleVista 640px, VerDiligencia 660px, settings 52ch),\n   so no blanket cap belongs here — a blanket 1200px cap was pinning content left\n   and leaving a right-side gap on wide screens. `.page--narrow` opts a whole view\n   into a centered measure when one is wanted. */\n.page {\n  padding: var(--s-8) var(--gutter) var(--s-20);\n}\n.page--wide {\n  max-width: none;\n}\n.page--narrow {\n  max-width: var(--content-max);\n  margin-inline: auto;\n}\n\n/* ---------- type utilities (scoped under .page where they collide) ---------- */\n.page .kicker {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  font-weight: 500;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n}\n.page .mono {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n}\n.page .serif {\n  font-family: var(--serif);\n  font-weight: 400;\n}\n.note {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  letter-spacing: 0.08em;\n  color: var(--ink-3);\n}\n\n/* ---------- toolbar + segmented control + pills ---------- */\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 0;\n  flex-wrap: wrap;\n}\n.toolbar__spacer {\n  flex: 1;\n}\n.chips {\n  display: flex;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 34px;\n  padding: 0 13px;\n  font-size: var(--fs-2xs);\n  border: 1px solid var(--rule);\n  background: transparent;\n  color: var(--ink-2);\n  border-radius: var(--r-pill);\n  cursor: pointer;\n  transition: all var(--dur-1) var(--ease);\n  white-space: nowrap;\n}\n.pill:hover {\n  border-color: var(--ink-3);\n  color: var(--ink);\n}\n.pill--on {\n  background: var(--accent-soft);\n  border-color: var(--accent);\n  color: var(--accent-deep);\n}\n.pill__n {\n  font-family: var(--mono);\n  font-size: var(--fs-eyebrow);\n  opacity: 0.8;\n}\n.seg {\n  display: inline-flex;\n  border: 1px solid var(--rule);\n  border-radius: var(--r-1);\n  overflow: hidden;\n}\n.seg button {\n  background: transparent;\n  border: 0;\n  height: 32px;\n  padding: 0 12px;\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  cursor: pointer;\n}\n.seg button.is-on {\n  background: var(--ink);\n  color: var(--paper);\n}\n\n/* ---------- tabs (lifecycle bar) ---------- */\n.tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 1px solid var(--rule);\n  flex-wrap: wrap;\n}\n.tab {\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  padding: 11px 16px 11px 0;\n  margin-right: 22px;\n  margin-bottom: -1px;\n  font-family: var(--sans);\n  font-size: var(--fs-note);\n  font-weight: 500;\n  color: var(--ink-3);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.tab:hover {\n  color: var(--ink);\n}\n.tab--on {\n  color: var(--ink);\n  border-bottom-color: var(--accent);\n}\n.tab__n {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--ink-3);\n}\n\n/* ---------- status text + dot ---------- */\n.st {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: var(--fs-ui);\n}\n.st__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  background: currentColor;\n  flex: none;\n}\n.st--ok {\n  color: var(--ok);\n}\n.st--warn {\n  color: var(--warn);\n}\n.st--err {\n  color: var(--err);\n}\n.st--info {\n  color: var(--info);\n}\n.st--mute {\n  color: var(--ink-3);\n}\n.st--ready {\n  color: var(--accent);\n}\n.st--live {\n  color: #1090ba;\n}\n\n/* ---------- bulk-selection bar ---------- */\n.selbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 14px;\n  border: 1px solid var(--accent);\n  background: var(--accent-soft);\n  margin: 14px 0 -1px;\n}\n.selbar--total {\n  border-color: var(--rule);\n  background: var(--paper-elev);\n}\n.selbar__n {\n  font-size: var(--fs-ui);\n  color: var(--ink);\n}\n.selbar__n b {\n  font-family: var(--mono);\n}\n.selbar__sp {\n  flex: 1;\n}\n\n/* ---------- dashed empty state + \"no diligencia\" cell ---------- */\n.empty {\n  border: 1px dashed var(--rule);\n  padding: 34px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n.empty__t {\n  font-size: var(--fs-note);\n  color: var(--ink);\n}\n.dil-none {\n  font-size: var(--fs-2xs);\n  color: var(--ink-3);\n}\n\n/* ---------- future-feature badge ---------- */\n.soon-badge {\n  font-family: var(--mono);\n  font-size: var(--fs-pico);\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  border: 1px solid var(--rule);\n  color: var(--ink-3);\n  padding: 1px 5px;\n  border-radius: 2px;\n  vertical-align: middle;\n  margin-left: 4px;\n}\n\n/* ---------- CSS tooltip (disambiguate a label) ---------- */\n.tip {\n  position: relative;\n  border-bottom: 1px dotted var(--ink-3);\n  cursor: help;\n}\n.tip::after {\n  content: attr(data-tip);\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% + 8px);\n  transform: translateX(-50%) translateY(4px);\n  background: var(--ink);\n  color: var(--paper);\n  font-family: var(--sans);\n  font-size: var(--fs-meta);\n  font-weight: 400;\n  line-height: 1.4;\n  letter-spacing: 0;\n  text-transform: none;\n  padding: 7px 10px;\n  width: max-content;\n  max-width: 240px;\n  white-space: normal;\n  text-align: left;\n  border-radius: var(--r-1);\n  opacity: 0;\n  pointer-events: none;\n  z-index: 120;\n  transition:\n    opacity var(--dur-1) var(--ease),\n    transform var(--dur-1) var(--ease);\n}\n.tip::before {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: calc(100% + 3px);\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: var(--ink);\n  opacity: 0;\n  pointer-events: none;\n  z-index: 120;\n  transition: opacity var(--dur-1) var(--ease);\n}\n.tip:hover::after {\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n}\n.tip:hover::before {\n  opacity: 1;\n}\nth .tip {\n  border-bottom: 0;\n  text-decoration: underline dotted var(--ink-3);\n  text-underline-offset: 3px;\n}\n/* A header tooltip opens below its cell: above it would leave .tbl-wrap, whose\n   overflow-x clips the top edge, and the th clipped it as well. */\nth .tip::after {\n  bottom: auto;\n  top: calc(100% + 8px);\n  transform: translateX(-50%) translateY(-4px);\n}\nth .tip::before {\n  bottom: auto;\n  top: calc(100% + 3px);\n  border-top-color: transparent;\n  border-bottom-color: var(--ink);\n}\n/* In the last or a right-aligned column the tooltip hangs to the left of its\n   label, so it never extends past the table's right edge (which would add a\n   horizontal scrollbar to .tbl-wrap). */\nth:last-child .tip::after,\nth.num .tip::after {\n  left: auto;\n  right: 0;\n  transform: translateY(-4px);\n}\nth:last-child .tip:hover::after,\nth.num .tip:hover::after {\n  transform: translateY(0);\n}\nth:last-child .tip::before,\nth.num .tip::before {\n  left: auto;\n  right: 8px;\n  transform: none;\n}\n\n/* ---------- reveal (screen enter) ---------- */\n@media (prefers-reduced-motion: no-preference) {\n  .reveal {\n    animation: reveal var(--dur-3) var(--ease);\n  }\n}\n@keyframes reveal {\n  from {\n    transform: translateY(6px);\n  }\n  to {\n    transform: none;\n  }\n}\n\n/* ---------- DS button (.t-btn) ---------- */\n.t-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  font-family: var(--sans);\n  font-size: var(--fs-ui);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  border: 1px solid var(--text);\n  background: var(--text);\n  color: var(--bg);\n  border-radius: var(--radius-0);\n  cursor: pointer;\n  transition: all var(--dur-1) var(--ease);\n  text-decoration: none;\n}\n.t-btn:hover {\n  background: color-mix(in oklab, var(--text) 82%, var(--bg));\n  border-color: color-mix(in oklab, var(--text) 82%, var(--bg));\n}\n.t-btn:active {\n  background: color-mix(in oklab, var(--text) 68%, var(--bg));\n}\n.t-btn:focus-visible {\n  outline: 2px solid var(--text);\n  outline-offset: 2px;\n}\n.t-btn--ghost {\n  background: transparent;\n  color: var(--text);\n}\n.t-btn--ghost:hover {\n  background: var(--bg-alt);\n}\n.t-btn--quiet {\n  background: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n}\n/* The base .t-btn:hover / :active paint a dark fill for the solid button. The\n   quiet variant keeps its transparent background, otherwise its dark hover\n   text lands on that fill. */\n.t-btn--quiet:hover {\n  background: transparent;\n  border-color: var(--text);\n  color: var(--text);\n}\n.t-btn--quiet:active {\n  background: color-mix(in oklab, var(--text) 8%, transparent);\n  border-color: var(--text);\n  color: var(--text);\n}\n.t-btn--sm {\n  padding: 6px 10px;\n  font-size: var(--fs-meta);\n}\n.t-btn--lg {\n  padding: 14px 22px;\n  font-size: var(--fs-note);\n}\n.t-btn--primary {\n  background: var(--signal);\n  border-color: var(--signal);\n  color: #fff;\n}\n.t-btn--primary:hover {\n  background: var(--signal-deep);\n  border-color: var(--signal-deep);\n}\n.t-btn[disabled],\n.t-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.t-btn .kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0;\n  opacity: 0.7;\n  border: 1px solid currentColor;\n  border-radius: 2px;\n  padding: 0 4px;\n  line-height: 1.4;\n}\n.t-btn--ghost .kbd,\n.t-btn--quiet .kbd {\n  border-color: var(--rule);\n}\n\n/* ---------- row-action (small secondary button in table rows / card tiles) ---------- */\n.row-action {\n  height: 26px;\n  padding: 0 11px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-1);\n  background: var(--bg-alt);\n  color: var(--text-secondary);\n  font-family: var(--sans);\n  font-size: var(--fs-xs);\n  font-weight: 500;\n  letter-spacing: -0.001em;\n  cursor: pointer;\n  transition:\n    background 110ms ease,\n    border-color 110ms ease,\n    color 110ms ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.row-action:hover {\n  background: var(--bg);\n  border-color: var(--text-secondary);\n  color: var(--text);\n}\n\n.row-action.danger {\n  color: var(--danger);\n  border-color: rgba(180, 35, 24, 0.35);\n}\n\n.row-action.danger:hover {\n  background: var(--err-bg);\n  border-color: var(--danger);\n}\n\n.row-action--disabled,\n.row-action--disabled:hover {\n  color: var(--text-muted);\n  border-color: var(--border);\n  background: var(--bg-alt);\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n/* ---------- DS checkbox (.t-check) ---------- */\n.t-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  font-size: var(--fs-note);\n}\n.t-check input {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  border: 1px solid var(--border);\n  background: var(--surface);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  border-radius: 2px;\n  margin: 0;\n}\n.t-check input:checked {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n.t-check input:checked::after {\n  content: '';\n  width: 10px;\n  height: 10px;\n  /* The check is a mask painted with --accent-ink, so it follows the accent\n     in both themes (a white stroke is unreadable on the dark accents). */\n  background: var(--accent-ink);\n  -webkit-mask: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10'><path d='M1 5L4 8L9 2' stroke='black' stroke-width='1.6' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")\n    center/contain no-repeat;\n  mask: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 10'><path d='M1 5L4 8L9 2' stroke='black' stroke-width='1.6' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>\")\n    center/contain no-repeat;\n}\n\n/* ── tag — mono mini pill, tone-tinted. Shared primitive used by\n   the diligencia detail, the Inicio foco cards, and any tone label. ── */\n.tag {\n  display: inline-flex;\n  align-items: center;\n  font-family: var(--mono);\n  font-size: 10px;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  padding: 2px 7px;\n  border: 1px solid var(--rule);\n  color: var(--ink-3);\n  border-radius: var(--radius-1, 2px);\n}\n.tag--ok {\n  border-color: var(--ok);\n  color: var(--ok);\n}\n.tag--err {\n  border-color: var(--err);\n  color: var(--err);\n}\n.tag--warn {\n  border-color: var(--warn);\n  color: var(--warn);\n}\n.tag--ready {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n.tag--info {\n  border-color: var(--info);\n  color: var(--info);\n}\n.tag--live {\n  border-color: var(--info);\n  color: var(--info);\n}\n.tag--mute {\n  border-color: var(--rule);\n  color: var(--ink-3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
